export class TimeConfig {
	startHours: number;
	endHours: number;

	daysOfWeek: number[];
}
